const route = {
	path: ':moduleId-:moduleName/resources',
	name: 'page-resource',
	meta: {
		title: 'Recursos',
	},
	component: () => import('@/pages/resources/page-resource'),
	props: true,
	children: [
		{
			path: ':id/edit',
			name: 'page-update-resource-edit',
			meta: {
				title: 'Editar Recurso',
			},
			component: () => import('@/pages/resources/page-resource-new-update'),
			props: true,
		},
		{
			path: ':id/assign-actions',
			name: 'page-resource-action',
			meta: {
				title: 'Asignar Barra de Acciones',
			},
			component: () => import('@/pages/resources/page-resource-action'),
			props: true,
		},
		{
			path: 'new',
			name: 'page-update-resource-new',
			meta: {
				title: 'Nuevo Recurso',
			},
			component: () => import('@/pages/resources/page-resource-new-update'),
			props: true,
		},
	],
};

export default route;



// WEBPACK FOOTER //
// ./src/router/resources.js